<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'app'
  }
</script>
<style>
  .ql-editor{
    min-height: 300px;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue